import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_VHCL_MDL_NO_INFO } from "./services/OsciVhclMkerMgmtService";

/*
 * Vehicle Maker Model Number
 * !== 차량 제조사 모델 넘버 ==!
 */
export const OSCI0105008S = (props: any) => {
    const { pgeUid } = usePage({ pgeUid: "osci0105008s" });
    const modal = useModal();
    const toast = useToast();
    const { vhclMkerCd, vhclMdlCd, vhclMdlNoCd, callback } = props;

    const form = {
        vhclMdlNoInfo: useForm({
            defaultSchema: SF_VHCL_MDL_NO_INFO,
        }),
    };

    const fetch = {
        getVhclMdlNoInfo: useFetch({
            api: (data) => APIS.getVhclMdlNoInfo(vhclMkerCd, vhclMdlCd, vhclMdlNoCd),
            enabled: !!vhclMdlNoCd,
            onSuccess: (data: any) => {
                form.vhclMdlNoInfo.setValues(data.vhclMdlNoInfo.content);
                form.vhclMdlNoInfo.setValue("mode", "MOD");
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        saveVhclMdlNoInfo: useFetch({
            api: (data: any) => APIS.saveVhclMdlNoInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        callback();
                    },
                });
            },
            onError: (data) => {
                modal.openModal({ content: data.response.data.errorMessage }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                // toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
    };

    const handler = {
        saveVhclMdlNoInfo: () => {
            if (!comnUtils.isEmpty(form.vhclMdlNoInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.vhclMdlNoInfo.handleSubmit(
                () => {
                    form.vhclMdlNoInfo.setValue("vhclMkerCd", vhclMkerCd);
                    form.vhclMdlNoInfo.setValue("vhclMdlCd", vhclMdlCd);
                    const data = form.vhclMdlNoInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveVhclMdlNoInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        if (comnUtils.isEmpty(vhclMdlNoCd)) {
            form.vhclMdlNoInfo.setSchema("vhclMdlNoCd", { edit: true });
            form.vhclMdlNoInfo.setValue("mode", "NEW");
        } else {
            form.vhclMdlNoInfo.setSchema("vhclMdlNoCd", { edit: false });
            form.vhclMdlNoInfo.setValue("mode", "MOD");
        }
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.vhclMdlNoInfo.schema.vhclMdlNoCd} />
                            <Group.Control {...form.vhclMdlNoInfo.schema.vhclMdlNoNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.vhclMdlNoInfo.schema.luxYn} />
                            <Group.Control {...form.vhclMdlNoInfo.schema.useYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
                <Layout>
                    <Layout.Right>
                        <Layout.Button role={"save"} onClick={handler.saveVhclMdlNoInfo} />
                    </Layout.Right>
                </Layout>
            </Group>
        </Page>
    );
};
